<template>
  <div>
    <div class="listContent">
      <div class="searchContent">
        <el-button
          icon="el-icon-plus"
          type="danger"
          @click="openAddBox(activeObj)"
          >添加工程</el-button
        >
        <!-- <el-button type="warning" plain>修改</el-button> -->
        <el-button type="info" @click="deleteSignAll(deleteStr)" plain
          >删除</el-button
        >
        <span class="searchInputText">工程名称</span>
        <el-input
          placeholder="请输入工程名称"
          v-model="search.projectName"
        ></el-input>
        <span class="searchInputText">工程类型</span>
        <el-select v-model="search.projectType" placeholder="请选择工程类型">
            <el-option
              v-for="item in projectTypeListAll"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        <el-button type="danger" @click="doSearchClick">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>
      <div class="listContain">
        <div class="tablelistBody">
          <el-table
            :data="dataList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            @selection-change="handleSelectionChange"
            :cell-class-name="cellcb"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              prop="order"
              label="序号"
              width="60"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              width=""
            ></el-table-column>
            <el-table-column
              prop="projectType"
              label="工程类型"
              width="100"
            >
            <template slot-scope="scope">
              <span v-if="scope.row.projectType==0">道路施工</span>
              <span v-if="scope.row.projectType==1">土方压实</span>
            </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="工程地址"
              width=""
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="startTime"
              label="开工时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="planEndTime"
              label="计划竣工时间"
              width="180"
            ></el-table-column>
            <!-- <el-table-column
              prop="supervisor"
              label="监理单位"
              width="180"
            ></el-table-column> -->
            <el-table-column
              prop="principal"
              label="负责人"
              width="120"
            ></el-table-column>
            <el-table-column label="操作" width="">
              <template slot-scope="scope">
                <span class="lookMore" @click="toInfo(scope.row)"
                  >查看更多</span
                >
                <span class="lookMore" @click="openModbox(scope.row)"  v-if="scope.row.sourceType == 1"
                  >修改</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="principalPhone"
              label="联系电话"
              width="140"
            ></el-table-column>
            <el-table-column label="设置" width="150">
              <!-- <template slot-scope="scope">
                <el-button @click="editHandleClick(scope.row)" type="text" size="small">编辑</el-button>
                <span style="color:#F14349">|</span>
                <el-button @click="deleteHandleClick(scope.row)" type="text" size="small">删除</el-button>
              </template>-->
              <template slot-scope="scope">
                <span
                  class="setProject"
                  @click="toActive(scope.row.id)"
                  v-if="scope.row.active == 0"
                  >设为当前工程</span
                >
                <span class="lookMore" v-if="scope.row.active == 1"
                  >当前工程</span
                >
              </template>
            </el-table-column>
            <el-table-column label="工程来源" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.sourceType == 0">本地平台</span>
                    <span v-if="scope.row.sourceType == 1">云平台</span>
                    <!-- <span class="lookMore" @click="openModbox(scope.row)">修改</span> -->
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="">
              <template slot-scope="scope">
                <span class="lookMore" @click="toInfo(scope.row)"
                  >查看更多</span
                >
                <span class="lookMore" @click="openModbox(scope.row)"  v-if="scope.row.sourceType == 1"
                  >修改</span
                >
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>

    <el-dialog
      :title="actionName"
      :visible.sync="addModBoxVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="borderBlock borderPadding addAndEdit engineering">
        <el-form
          :rules="rules"
          :model="modelObj"
          ref="addModForm"
          label-width="100px"
          @submit.native.prevent
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="名称" required prop="name">
                <el-input
                  v-model="modelObj.name"
                  maxlength="10"
                  placeholder="请输入名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工程地址" required prop="address">
                <el-input
                  v-model="modelObj.address"
                  maxlength="10"
                  placeholder="请输入工程地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="工程类型" required prop="projectType">
                <el-select v-model="modelObj.projectType" placeholder="请选择工程类型" :disabled="isMode">
                <el-option
                  v-for="item in projectTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开工时间" required prop="startTime">
                <el-date-picker
                  v-model="modelObj.startTime"
                  type="date"
                  placeholder="选择日期时间"
                  align="right"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            </el-row>
          <el-row>
            
          
            <el-col :span="12">
              <el-form-item label="计划竣工时间" required prop="planEndTime">
                <el-date-picker
                  v-model="modelObj.planEndTime"
                  type="date"
                  placeholder="选择日期时间"
                  align="right"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="施工单位"  prop="consUnit">
                <el-input
                  v-model="modelObj.consUnit"
                  maxlength="20"
                  placeholder="请输入施工单位"
                ></el-input>
              </el-form-item>
            </el-col>
            </el-row>
          <el-row>
            
          
            <el-col :span="12">
              <el-form-item label="监理单位"  prop="supervisor">
                <el-input
                  v-model="modelObj.supervisor"
                  maxlength="20"
                  placeholder="请输入监理单位"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人"  prop="principal">
                <el-input
                  v-model="modelObj.principal"
                  maxlength="10"
                  placeholder="请输入负责人"
                ></el-input>
              </el-form-item>
            </el-col>
            </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话"  prop="principalPhone">
                <el-input
                  v-model="modelObj.principalPhone"
                  maxlength="11"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-form-item label="联系电话">
              <el-input v-model="modelObj.active" maxlength="11" placeholder="请输入联系电话"></el-input>
          </el-form-item>-->
          <div style="clear: both"></div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModBoxVisible = false">取消</el-button>
        <el-button type="primary" @click="addModSubmit">{{
          actionName
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEnginList as fetchDtList,
  addEngin as addPost,
  editEngin as modPut,
  deleteEngin as delPut,
  activeEngin,
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";

import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {

    return {
      listLoading:false,
      input1: "",
      list: [{}],
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      search: {
        projectType:'',
        projectName: "",
        pageSize: 10,
        pageNo: 1,
      },
      modelObj: {},
      activeObj: {
        active: "0",
      },
      pickerOptions: {},
      deleteStr: "",
      fieldKey: "ids",
      projectTypeList:[],
      projectTypeListAll:[],
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/engineeringCenter",
        },
        {
          name: "工程管理",
          path: "/transfer/engineeringList",
        },
      ],
      isMode:false,//是否允许修改工程类型
      // rules: {
      //   principalPhone: [
      //     { required: true, message: "请输入手机号", trigger: "blur" },
      //     {
      //       validator: checkMobile,
      //       trigger: "blur",
      //     },
      //   ],
      // },
    };
  },
  computed: {
    rules: function () {
      var checkMobile = (rule, value, callback) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (regMobile.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };
      return {
        name: [{ required: true, message: "必填" }],
        address: [{ required: true, message: "必填" }],
        // createTime: [{ required: true, message: "必填" }],
        startTime: [{ required: true, message: "必填" }],
        planEndTime: [{ required: true, message: "必填" }],
        projectType: [{ required: true, message: "必填" }],
        // supervisor: [{ required: true, message: "必填" }],
        // principal: [{ required: true, message: "必填" }],
        principalPhone: [{ validator: checkMobile, trigger: "blur", }],
        // consUnit: [{ required: true, message: "必填" }],
      };
    },
  },
  created() {
    this.projectTypeListAll=this.$store.state.projectTypeAll
    this.projectTypeList=this.$store.state.projectType
  },
  mounted() {
    //console.log(this.$store.state.arrowList)
    this.doSearch();
    this.$store.commit("setArrowList", this.arrowList);
  },
  methods: {
    fetchDtList,
    addPost,
    modPut,
    delPut,
    cellcb(row){

        if(row.row.sourceType === 0){

            return "myCell"
        }
    },
    // getDataList: function(){
    //     fetchDtList(this.search).then(res => {
    //         //console.log(res)
    //         this.list = addOrder(res.data.content.info.list)
    //         this.pageMsg = this.pageAssign(res.data.content.info);
    //     })
    // },
    //鼠标点击查找按钮，先对pageNo置1
    doSearchClick: function() {
        this.search.pageNo=1
        this.getDataList(this.search, { listKey: "list" });
    },
    doSearch: function () {
      // this.search = {
      //   projectType:'',
      //   projectName: "",
      //   pageSize: 10,
      //   pageNo: 1,
      // },
      this.getDataList(this.search, { listKey: "list" });
    },
    toActive: function (setId) {
      let params = {
        id: setId,
      };
      activeEngin(params).then((res) => {
        console.log(res);
        this.getDataList(this.search, { listKey: "list" });
      });
    },
    handleSelectionChange: function (val) {
      //console.log(val)
      let deleteArr = [];
      for (let i = 0; i < val.length; i++) {
        deleteArr.push(val[i].id);
      }
      this.deleteStr = deleteArr.join(",");
    },
    toInfo: function (e) {
      //console.log(e)
      this.$router.push({ name: "EngineeringInfo", params: { id: e.id } });
    },
  },
  components: {
    ElPageCover,
  },
};
</script>
<style lang="scss">
.engineering {
  .el-input {
    width: 220px !important;
  }
}
 .myCell .el-checkbox__input {

  display: none

}
</style>
<style lang="scss" scoped="">
.listContent {
  height: 750px;
  width: 98.5%;
  margin: 0 auto;
  background-color: #ffffff;
  .searchContent {
    height: 70px;
    width: 80%;
    padding: 17.5px 17px;
  }
}
.listContain {
  width: 98.5%;
  margin: 0 auto;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}
</style>